var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('referenced-calendar-widget',{staticClass:"h-100",class:_vm.menuType==='vertical'|| _vm.isMobile?'':'mt-5',attrs:{"editable":""}})}
var staticRenderFns = []

export { render, staticRenderFns }